import {Component} from '@angular/core';
import {SubscribedComponent} from "../subscribed.component";
import {Globals} from "../shared/Globals";
import {AuthService} from "../shared/auth.service";
import {User, UserStatus} from "../interfaces/user";
import {FormBuilder} from "@angular/forms";
import {UsersService} from "../shared/users.service";
import {PasswordReset} from "../interfaces/password-reset";
import moment from 'moment';
import {TranslateService} from "@ngx-translate/core";
import {NotifierService} from "../shared/notifier.service";
import { saveAs as importedSaveAs } from "file-saver-es";
import {Router} from "@angular/router";
import {NbLayoutScrollService} from "@nebular/theme";

@Component({
    selector: 'bst-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss', '../project/projects.component.scss'],
    standalone: false
})
export class SettingsComponent extends SubscribedComponent {


  public UserStatus = UserStatus;
  public Globals = Globals;
  public me: User;
  public deleteRefused: string;
  public passwordForm = this.fb.group({

  });

  constructor(public auth: AuthService,
              private userService: UsersService,
              private translate: TranslateService,
              private notifier: NotifierService,
              private router: Router,
              public scroll: NbLayoutScrollService,
              private fb: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.mapUser();
  }

  private async mapUser(){
    this.loading.next(true);
    this.me = await this.auth.me;
    console.log(this.me);
    this.loading.next(false);
  }

  public get passwordResetting(){
    const last = this.lastPasswordReset;
    if(last && !last.sent_at && moment(last.created_at).add(60, 'minute') > moment()) {
      return last;
    }
    return null;
  }

  public get lastPasswordReset(): PasswordReset{
    if(this.me && this.me.passwords && this.me.passwords.length){
      return this.me.passwords[0];
    }
    return null;
  }

  public async verify(){
    if(this.me){
      this.loading.next(true);
      await this.userService.verifyUser(this.me.id);
      this.loading.next(false);
    }
  }

  public async resetPassword(){
    this.loading.next(true);
    try {
      const response = await this.auth.resetPassword(this.me.username);
      if(response && response.data){
        this.me.passwords.unshift(response.data);
        await this.notifier.notify('currentlyresetting', 'success', 'primary', 'email-outline');
      }
    } catch (e) {
      console.error('password reset failed', e);
    } finally {
      this.loading.next(false);
    }
  }

  public async removeSocial(provider: string) {
    if(!this.me.has_password){
      return await this.notifier.notify('linkedincannotdelete', 'error', 'danger');
    }

    const choice = await this.notifier.confirm('sure?', 'linkedindeletecheck');
    if(choice){
      this.loading.next(true);
      try {
        this.me = await this.auth.removeProvider(provider);
        await this.notifier.notify('linkedinremoved', 'success', 'primary');
      } catch (e) {
        console.error('provider remove failed', e);
      } finally {
        this.loading.next(false);
      }
    }
  }

  public async downloadme() {
    this.loading.next(true);
    try {
      const blob: Blob = await this.userService.export([this.me.id]);
      importedSaveAs(blob, 'my_teamertime_data_'+moment().format('DD-MM-YYYY')+'.csv');
    } catch (e) {
      console.error('export failed', e);
    } finally {
      this.loading.next(false);
    }
  }

  public async deleteme(){
    const de = await this.translate.get('accountdelete').toPromise();
    const sure = await this.notifier.confirm('sure?', de, 'deleteme', 'danger');
    if(sure){
      try {
        this.loading.next(true);
        await this.userService.deleteUser(this.me.id);
        this.loading.next(false);
        this.auth.clear();
        await this.notifier.notify('success', 'goodbye', 'success');
        await this.router.navigate(['login']);
      }
      catch(error){
        this.loading.next(false);
        // The API service already toasted the failure; a refusal (409) also stays on the page.
        this.deleteRefused = error?.status === 409 ? error.error?.message : null;
      }
    }
  }
}
